import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 3,
    seconds: 33
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 3;
          seconds = 33;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-8 sm:py-10 px-4 bg-white border-y border-brand-gold/30 scroll-mt-10" data-id="element-152" data-mp="2xkrf5ulcu08v">
      <div className="max-w-2xl mx-auto" data-id="element-153" data-mp="32kc6eol0lu74">
        <div className="text-center mb-5" data-id="element-154" data-mp="32lnc4ty0tc0v">
          <p className="text-sm font-bold text-brand-gold uppercase tracking-wide mb-2" data-id="element-155" data-mp="32mop53ylk8l8">
            SPECIAL OFFER — COMPLETE 6-IN-1 SYSTEM
          </p>
          <p className="text-base text-brand-graphite/80 mb-3" data-id="element-156" data-mp="2strd9go41hvl">
            Access the system now and transform your coaching today
          </p>
          <div className="inline-block bg-brand-petrol/10 border-2 border-brand-petrol px-4 py-1.5 rounded-lg" data-id="element-157" data-mp="2xr9dmio2aorz">
            <p className="font-bold text-brand-petrol text-lg" data-id="element-158" data-mp="2osny6wdvzpvf">
              FUNCTIONAL PRO™ 6-in-1 Complete System
            </p>
          </div>
        </div>

        <div className="bg-brand-cream border-4 border-brand-gold rounded-xl p-5 sm:p-6 text-center relative mb-5" data-id="element-159" data-mp="29xhp20jhvaxv">
          <div className="mb-5" data-id="element-160" data-mp="2ewkwfrmy5t90">
            <p className="text-base text-brand-graphite/70 mb-1" data-id="element-161" data-mp="83sarmpu410d">
              Normal Price: <span className="line-through" data-id="element-162" data-mp="d3enzw5nxh96">$97 USD</span>
            </p>
            <p className="text-lg font-bold text-red-600 mb-3" data-id="element-163" data-mp="d1ai58o7e869">
              72% OFF — LAUNCH OFFER
            </p>
            <p className="text-sm text-brand-graphite/70 mb-2" data-id="element-164" data-mp="6n4miotz3qi8">
              Limited Time Price:
            </p>
            <p className="text-5xl font-serif font-bold text-brand-petrol mb-2" data-id="element-165" data-mp="1nrzo433qjfn">
              $27 USD
            </p>
            <p className="text-sm text-brand-graphite/70" data-id="element-166" data-mp="3tsm88fzlwksa">
              Pay in your local currency
            </p>
          </div>

          <div className="bg-red-50 border-2 border-red-300 rounded-lg p-4 mb-6" data-id="element-167" data-mp="ubxn4yljimj6">
            <p className="text-sm font-bold text-red-600 mb-3" data-id="element-168" data-mp="pexf4i54r9pf">
              🔥 Last chance! The price increases when the timer ends.
            </p>
            <div className="flex justify-center gap-4" data-id="element-169" data-mp="glan9341mqli">
              <div className="text-center" data-id="element-170" data-mp="gkstqe8rmqha">
                <div className="bg-brand-petrol text-white text-2xl font-bold px-4 py-2 rounded" data-id="element-171" data-mp="1d2yjrfz6u5zk">
                  {String(timeLeft.hours).padStart(2, '0')}
                </div>
                <p className="text-xs text-brand-graphite/70 mt-1" data-id="element-172" data-mp="18anjud4g6k70">HOURS</p>
              </div>
              <div className="text-center" data-id="element-173" data-mp="2r1bc71wceqgt">
                <div className="bg-brand-petrol text-white text-2xl font-bold px-4 py-2 rounded" data-id="element-174" data-mp="2vxjkbvc4hjeh">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </div>
                <p className="text-xs text-brand-graphite/70 mt-1" data-id="element-175" data-mp="34yrjefmgqo9m">MINUTES</p>
              </div>
              <div className="text-center" data-id="element-176" data-mp="39yceug2fcehl">
                <div className="bg-brand-petrol text-white text-2xl font-bold px-4 py-2 rounded" data-id="element-177" data-mp="39xkw45txeb8q">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </div>
                <p className="text-xs text-brand-graphite/70 mt-1" data-id="element-178" data-mp="3joypdvvaaetf">SECONDS</p>
              </div>
            </div>
          </div>

          <CTAButton href="https://functionalpro.impultienda.ar/checkout" data-id="element-179" data-mp="3nopmehbelr6e">
            🚀 YES, I WANT THE COMPLETE SYSTEM ($27)
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-brand-graphite/70" data-id="element-180" data-mp="1hhkxq3lu4fn">
          <div className="flex items-center gap-1" data-id="element-181" data-mp="3jzn62neh3fjv">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-182" data-mp="3f24vytopyuaa" />
            <span className="font-semibold" data-id="element-183" data-mp="3ezsfkkym0rzc">4.9/5 — Verified Reviews</span>
          </div>
          <span className="hidden sm:inline" data-id="element-184" data-mp="3tpzooa2q8ynd">•</span>
          <div className="flex items-center gap-1" data-id="element-185" data-mp="3or50eslzqhvv">
            <Shield className="w-4 h-4 text-brand-petrol" data-id="element-186" data-mp="3otrfref4i1on" />
            <span className="font-semibold" data-id="element-187" data-mp="313565iph09cj">7-Day Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}